// extracted by mini-css-extract-plugin
module.exports = {"place":"HHnp2","link":"mYXnM","text":"EgKkP","icon":"CU8Af","size_medium":"CTwwr","size_large":"pTFFH"};